import { useState } from 'react';
import { Link } from 'react-router-dom';

const GoogleReviewsSection = () => {
  const [hoveredCard, setHoveredCard] = useState<number | null>(null);

  const reviews = [
    {
      id: 1,
      name: '陳先生',
      avatar: '陳',
      location: '新北市泰山區',
      rating: 5,
      date: '1 週前',
      comment: '搬家師傅非常專業，對於家具的防護包裝做得相當精緻且到位，確保物品在運輸過程中不受損。動作迅速且俐落，分工明確，搬運效率很高。態度親切有耐心，讓整個搬家過程很順利！',
      service: '家庭搬家',
      verified: true,
      featured: true
    },
    {
      id: 2,
      name: '林小姐',
      avatar: '林',
      location: '台北市大安區',
      rating: 5,
      date: '2 週前',
      comment: '報價非常實在且透明，不會隨意加價。搬家前線上估價系統很方便，讓我在預約前就能有清楚的預算參考。搬家當天服務品質超乎預期！',
      service: '精緻搬家',
      verified: true,
      featured: false
    },
    {
      id: 3,
      name: '王太太',
      avatar: '王',
      location: '桃園市中壢區',
      rating: 5,
      date: '3 週前',
      comment: '沙發和床墊的防護包裝做得特別好，搬運過程非常小心。師傅們很有經驗，對於大型家具的拆裝都很專業。價格合理，服務態度也很好，非常推薦！',
      service: '套房搬遷',
      verified: true,
      featured: false
    },
    {
      id: 4,
      name: '張先生',
      avatar: '張',
      location: '新北市板橋區',
      rating: 5,
      date: '1 個月前',
      comment: '第二次找建鈞搬家了！上次搬家的經驗很好，這次又再次選擇他們。師傅們動作快又仔細，對長輩很有耐心，讓人很放心。24小時服務真的很方便！',
      service: '家庭搬家',
      verified: true,
      featured: false
    },
    {
      id: 5,
      name: '李小姐',
      avatar: '李',
      location: '新竹市東區',
      rating: 5,
      date: '2 週前',
      comment: 'LINE 諮詢回覆很快，報價清楚透明。搬家當天師傅們準時到達，效率超高！家具都保護得很好，沒有任何損傷。全省回頭車服務讓長途搬家也很划算！',
      service: '長途搬家',
      verified: true,
      featured: false
    },
    {
      id: 6,
      name: '黃先生',
      avatar: '黃',
      location: '新北市新莊區',
      rating: 5,
      date: '1 個月前',
      comment: '廢棄物清運服務很專業，把不要的舊家具都清得乾乾淨淨。師傅們很細心，會先確認哪些要留哪些要丟。價格合理，服務態度也很好，大推！',
      service: '廢棄物處理',
      verified: true,
      featured: false
    }
  ];

  const overallRating = 5.0;
  const totalReviews = 71;

  // 建鈞精緻搬家的 Google 地圖商家連結 - 使用正確的搜尋格式
  const googleMapsReviewUrl = 'https://www.google.com/maps/search/%E5%BB%BA%E9%88%9E%E7%B2%BE%E7%B7%BB%E6%90%AC%E5%AE%B6+%E6%96%B0%E5%8C%97%E5%B8%82%E6%B3%B0%E5%B1%B1%E5%8D%80%E7%A6%8F%E5%BE%B7%E8%A1%9749%E8%99%9F3%E6%A8%93';

  return (
    <section className="py-16 md:py-24 bg-gradient-to-b from-white via-gray-50/50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* 標題區域 */}
        <div className="text-center mb-12 md:mb-16">
          {/* Google 標籤 */}
          <div className="inline-flex items-center gap-2 bg-white border border-gray-200 rounded-full px-4 py-2 shadow-sm mb-6">
            <svg className="w-5 h-5" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            <span className="text-sm font-medium text-gray-700">Google 商家評論</span>
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            <strong>客戶真實評價</strong>
          </h2>
          
          {/* 評分展示 */}
          <div className="flex items-center justify-center gap-4 mb-4">
            <div className="flex items-center gap-2">
              <span className="text-4xl md:text-5xl font-bold text-gray-900">{overallRating}</span>
              <div className="flex flex-col items-start">
                <div className="flex gap-0.5">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className={`ri-star-fill text-xl ${i < Math.floor(overallRating) ? 'text-yellow-400' : 'text-gray-300'}`}></i>
                  ))}
                </div>
                <span className="text-sm text-gray-500">基於 {totalReviews} 則評論</span>
              </div>
            </div>
          </div>

          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            超過 <strong className="text-teal-600">{totalReviews}+</strong> 位客戶的真實好評，見證建鈞搬家的專業服務品質
          </p>
        </div>

        {/* 評論卡片網格 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {reviews.map((review, index) => (
            <div
              key={review.id}
              className={`relative bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 ${
                review.featured ? 'md:col-span-2 lg:col-span-1 ring-2 ring-teal-200' : ''
              }`}
              onMouseEnter={() => setHoveredCard(index)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              {/* 精選標記 */}
              {review.featured && (
                <div className="absolute -top-3 left-6 bg-gradient-to-r from-teal-500 to-emerald-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-md">
                  ⭐ 精選評論
                </div>
              )}

              {/* 用戶資訊 */}
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className={`w-12 h-12 rounded-full flex items-center justify-center text-white font-bold text-lg ${
                    review.featured 
                      ? 'bg-gradient-to-br from-teal-500 to-emerald-500' 
                      : 'bg-gradient-to-br from-gray-400 to-gray-500'
                  }`}>
                    {review.avatar}
                  </div>
                  <div>
                    <div className="flex items-center gap-2">
                      <h3 className="font-bold text-gray-900">{review.name}</h3>
                      {review.verified && (
                        <i className="ri-verified-badge-fill text-blue-500 text-sm" title="已驗證評論"></i>
                      )}
                    </div>
                    <p className="text-sm text-gray-500 flex items-center gap-1">
                      <i className="ri-map-pin-line text-xs"></i>
                      {review.location}
                    </p>
                  </div>
                </div>
                
                {/* Google 圖示 */}
                <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24">
                  <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                  <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                  <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                  <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                </svg>
              </div>

              {/* 評分星星 */}
              <div className="flex items-center gap-2 mb-3">
                <div className="flex gap-0.5">
                  {[...Array(review.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400"></i>
                  ))}
                </div>
                <span className="text-sm text-gray-400">{review.date}</span>
              </div>

              {/* 評論內容 */}
              <p className="text-gray-700 leading-relaxed mb-4 line-clamp-4">
                「{review.comment}」
              </p>

              {/* 服務標籤 */}
              <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                <span className="bg-teal-50 text-teal-700 px-3 py-1 rounded-full text-sm font-medium">
                  {review.service}
                </span>
                <div className="flex items-center gap-1 text-gray-400 text-sm">
                  <i className="ri-thumb-up-line"></i>
                  <span>有幫助</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* 底部 CTA */}
        <div className="text-center">
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
            <a
              href={googleMapsReviewUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-white border-2 border-gray-200 text-gray-700 px-6 py-3 rounded-full font-semibold hover:border-teal-500 hover:text-teal-600 transition-all cursor-pointer whitespace-nowrap shadow-sm hover:shadow-md"
            >
              <svg className="w-5 h-5" viewBox="0 0 24 24">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              查看所有 Google 評論
              <i className="ri-external-link-line"></i>
            </a>
            <a
              href="https://line.me/ti/p/@285yavdh"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-gradient-to-r from-teal-600 to-emerald-600 text-white px-8 py-3 rounded-full font-semibold hover:from-teal-700 hover:to-emerald-700 transition-all cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl"
            >
              <img 
                src="https://static.readdy.ai/image/9ef47c451bf9aafd7a63eea67af7d95d/c33a3c3f2fa31df7dfad05bfabc09369.webp" 
                alt="LINE" 
                className="w-5 h-5"
              />
              立即 LINE 諮詢
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          {/* 信任標記 */}
          <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-gray-500">
            <div className="flex items-center gap-2">
              <i className="ri-shield-check-line text-teal-600"></i>
              <span>100% 真實評論</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-verified-badge-line text-blue-500"></i>
              <span>Google 官方認證</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-star-line text-yellow-500"></i>
              <span>5.0 星滿分評價</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GoogleReviewsSection;